import { SectionHeader } from "./SectionHeader";

const BENCHMARKS = [
    {
        id: "benchmark-1",
        partner: "RelayStack",
        harness: "Claude Code",
        label: "TURNS PER TASK, 3-BUG CODING FIXTURE",
        metric: "-21%",
        without: 15,
        with: 12,
        note: "412 runs, every one passed.",
    },
    {
        id: "benchmark-2",
        partner: "Forgebase",
        harness: "Codex",
        label: "TOOL CALLS PER TASK, SAME FIXTURE",
        metric: "-38%",
        without: 6,
        with: 4,
        note: "Three replications, same result each time.",
    },
];

const Benchmarks = () => (
    <section id="benchmarks" data-testid="benchmarks-section" className="border-t border-[#262626]">
        <div className="mx-auto max-w-6xl px-4 py-20 sm:px-6 sm:py-28">
            <SectionHeader id="benchmarks">Benchmarks</SectionHeader>
            <div className="grid gap-px border border-[#262626] bg-[#262626] sm:grid-cols-2">
                {BENCHMARKS.map((b) => (
                    <div
                        key={b.id}
                        data-testid={b.id}
                        className="group flex flex-col bg-[#050505] p-8 transition-colors duration-200 hover:bg-[#0a0a0a]"
                    >
                        <div className="flex items-center justify-between">
                            <span className="text-sm font-medium text-neutral-100">{b.partner}</span>
                            <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-neutral-500">
                                {b.harness}
                            </span>
                        </div>
                        <span className="mt-1 font-mono text-[10px] uppercase tracking-[0.3em] text-neutral-600">
                            {b.label}
                        </span>
                        <span className="mt-6 font-mono text-5xl font-semibold text-green-400">{b.metric}</span>
                        <div className="mt-6 space-y-2 font-mono text-xs">
                            <div className="flex items-center gap-3">
                                <span className="w-32 text-neutral-500">Without memory</span>
                                <div className="h-2 bg-neutral-700" style={{ width: `${b.without * 10}px` }} />
                                <span className="text-neutral-400">{b.without}</span>
                            </div>
                            <div className="flex items-center gap-3">
                                <span className="w-32 text-neutral-500">With remembered.sh</span>
                                <div className="h-2 bg-green-400" style={{ width: `${b.with * 10}px` }} />
                                <span className="text-green-400">{b.with}</span>
                            </div>
                        </div>
                        <span className="mt-6 text-sm text-neutral-500">{b.note}</span>
                    </div>
                ))}
            </div>
        </div>
    </section>
);

export default Benchmarks;
